import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import pData from '../hybriddata/propertydata.json'; 
import { CusFormLabel } from '../validation/Form-Components';
import helper from '../factory/Helper';
 

const LeaseholdPreview = (props) => { 

    const {response} = props

    return(
        <div>
            <Field component={CusFormLabel} 
                leftLabelId={'lblIsLeasehold'} leftLabelName={pData.label.isLeasehold}
                id={'isLeasehold'} name={response.PropertyDetails.IsLeaseHoldDescription !== null?response.PropertyDetails.IsLeaseHoldDescription:'Not Applicable'}/>

            {response.PropertyDetails.IsLeaseHold === 'Y' &&
            <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblleaseHoldEffDate'} leftLabelName={pData.label.leaseHoldEffDate}
                    id={'leaseHoldEffDate'} name={response.PropertyDetails.LeaseHoldEffDate !== null?helper.formatDateDDMMYYYY(response.PropertyDetails.LeaseHoldEffDate):'Not Applicable'}/>
 
                <Field component={CusFormLabel} 
                    leftLabelId={'lbloriginalLeaseHold'} leftLabelName={pData.label.originalLeaseHold}
                    id={'originalLeaseHold'} 
                    name={response.PropertyDetails.OriginalLeaseHoldDescription !== null?response.PropertyDetails.OriginalLeaseHold === 'Others'?(response.PropertyDetails.OriginalLeaseHoldOthers+' Years'):response.PropertyDetails.OriginalLeaseHoldDescription:'Not Applicable'}/>
            </div>
            }
        </div>
    )
}


export default LeaseholdPreview
